<template>
    <form class="form">
        <div class="form__conteiner">
            <div class="form__field">
                <input
                    class="form__input"
                    type="text"
                    name="data[project_name]"
                    v-model="data.project_name"
                />
                <span
                    class="form__field-lable"
                    :class="{ 'form__field-lable--active': data.project_name }"
                >Project Name</span>
            </div>
            <div class="form__field">
                <input class="form__input" type="text" name="data[host]" v-model="data.host" />
                <span
                    class="form__field-lable"
                    :class="{ 'form__field-lable--active': data.host }"
                >Host</span>
            </div>
            <div class="form__field">
                <input class="form__input" name="data[login]" v-model="data.login" />
                <span
                    class="form__field-lable"
                    :class="{ 'form__field-lable--active': data.login }"
                >Login</span>
            </div>
            <div class="form__field">
                <input
                    class="form__input"
                    type="text"
                    name="data[password]"
                    v-model="data.password"
                />
                <span
                    class="form__field-lable"
                    :class="{ 'form__field-lable--active': data.password }"
                >Password</span>
            </div>
            <div class="form__field">
                <input
                    class="form__input"
                    type="text"
                    name="data[type]"
                    v-model="data.type"
                />
                <span
                    class="form__field-lable"
                    :class="{ 'form__field-lable--active': data.type }"
                >Type</span>
            </div>
            <div class="form__field form__field--comment">
                <textarea class="form__input" rows="5" name="data[comment]" v-model="data.comment" />
                <span
                    class="form__field-lable"
                    :class="{ 'form__field-lable--active': data.comment }"
                >Comment</span>
            </div>
        </div>
        <div class="form__btn">
            <BtnOk @clickokay="popupOpen = !popupOpen" />
            <BtnCancel @clickcencel="closeEdit" />
        </div>
        <PopUp
            :isOpen="popupOpen"
            @popupclickokay="submitEditForm"
            @popupclickcencel="popupOpen = false"
            text="Изменить элемент?"
        />
    </form>
</template>

<script>
import BtnOk from "@/components/form/BtnOk.vue";
import BtnCancel from "@/components/form/BtnCancel.vue";
import PopUp from "@/components/PopUp.vue";
import qs from "qs";

export default {
    components: {
        BtnOk,
        BtnCancel,
        PopUp
    },

    props: {
        accessData: {
            default: () => {},
            type: Object
        }
    },

    data() {
        return {
            data: this.accessData,
            popupOpen: false,
        };
    },

    methods: {
        closeEdit() {
            this.$emit("closeedit");
        },
        submitEditForm() {
            this.axios
                .post(
                    "/api/edit/" + this.data.id,
                    qs.stringify({ data: this.data })
                )
                .then(() => {
                    this.popupOpen = false;
                    this.$emit("edit");
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        pressKey(e) {
            this.save(e);
        },
        save(e) {
            if (e.ctrlKey && e.keyCode === 83) { 
                e.preventDefault();
                this.submitEditForm();
            }
        }
    },

    created() {
        window.addEventListener("keydown", this.pressKey);
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.pressKey);
    },
};
</script>

<style lang="sass" scoped>
.form
    position: absolute
    top: 100%
    left: 0
    right: 0
    z-index: 10
    padding-top: 45px
    border-top: 1px solid $grey
    background-color: $grey-l
</style>